import React from "react";
import Ratings from "react-star-ratings";
import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import Fonts from "../assets/Fonts";
import classes from "./ReviewsOnSidebar.module.css";
import Colors from "../assets/Colors";

export const ReviewsWithRating = ({ title, progress, rating }) => {
  return (
    <Row className={[classes.mb8].join(" ")}>
      <Col xs={6} md={12} lg={6}>
        <span
          className={`${[classes.reviewTitle].join(" ")}`}
          style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}
        >
          {title}
        </span>
      </Col>
      <Col xs={6} md={12} lg={6} className={`${[classes.acenter].join(" ")}`}>
        <div
          className={`${[classes.progressContainer].join(" ")}`}
          style={{ backgroundColor: Colors.neutralShadesOfWhisper }}
        >
          <div
            className={`${[classes.progressLine].join(" ")}`}
            style={{
              width: progress,
              backgroundColor: Colors.mainShadeOfRed,
            }}
          />
        </div>
        <span
          className={`${[classes.ml24].join(" ")}`}
          style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}
        >
          {rating}
        </span>
      </Col>
    </Row>
  );
};

export const ReviewsOnSidebar = ({ rating, totalRating, reviewsTypes }) => {
  return (
    <div>
      <h1
        style={{
          color: Colors.neutralShadesOfNero,
          ...Fonts.h1,
          margin: "0px 0px 8px 0px",
        }}
      >
        {rating.toFixed(1)}
      </h1>
      <Row className={["g-0", classes.mb32].join(" ")}>
        <Col lg={8} className={[classes.mb8Onlg]}>
          <Ratings
            numberOfStars={5}
            starRatedColor={Colors.mainShadeOfRed}
            starEmptyColor={Colors.neutralShadesOfGainsboro}
            rating={rating}
            starDimension={"24px"}
            starSpacing={"4px"}
          />
        </Col>
        <Col lg={4}>
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
            ({totalRating} ratings)
          </p>
        </Col>
      </Row>
      <div className={[classes.mb24].join(" ")}>
        {reviewsTypes?.map((item) => {
          return (
            <ReviewsWithRating
              title={item?.title}
              rating={item?.rating}
              progress={item?.progress}
            />
          );
        })}
      </div>
    </div>
  );
};
ReviewsOnSidebar.propTypes = {
  totalReviews: PropTypes.number,
  rating: PropTypes.number,
  reviewsTypes: PropTypes.array,
};
ReviewsOnSidebar.defaultProps = {
  totalReviews: 12,
  rating: 3.2,
  reviewsTypes: [
    {
      title: "Accuracy",
      progress: "60%",
      rating: "4.0",
    },
    {
      title: "Location",
      progress: "100%",
      rating: "5.0",
    },
    {
      title: "Value",
      progress: "40%",
      rating: "3.0",
    },
    {
      title: "Communication",
      progress: "100%",
      rating: "5.0",
    },
  ],
};
